/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRestriction} from '../api'

 export const useQueryGetRestriction = createReactQueryHook('getRestriction', getRestriction)
